var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3761 6.57169C11.3761 5.76645 11.1795 5.01738 10.7862 4.3245C10.3742 3.63161 9.82177 3.07918 9.12889 2.66719C8.41728 2.27394 7.66822 2.07731 6.8817 2.07731C6.09518 2.07731 5.34612 2.27394 4.63451 2.66719C3.94162 3.07918 3.38919 3.63161 2.9772 4.3245C2.58395 5.01738 2.38732 5.76645 2.38732 6.57169C2.38732 7.37693 2.58395 8.126 2.9772 8.81888C3.38919 9.51176 3.94162 10.0642 4.63451 10.4762C5.34612 10.8694 6.09518 11.0661 6.8817 11.0661C7.66822 11.0661 8.41728 10.8694 9.12889 10.4762C9.82177 10.0642 10.3742 9.51176 10.7862 8.81888C11.1795 8.126 11.3761 7.37693 11.3761 6.57169ZM10.5053 11.1503C9.49406 11.9743 8.28619 12.3957 6.8817 12.4144C5.23376 12.3769 3.85735 11.8058 2.75248 10.7009C1.64762 9.59603 1.07645 8.21963 1.039 6.57169C1.07645 4.92375 1.64762 3.54734 2.75248 2.44248C3.85735 1.33761 5.23376 0.766446 6.8817 0.728992C8.52964 0.766446 9.90604 1.33761 11.0109 2.44248C12.1158 3.54734 12.6869 4.92375 12.7244 6.57169C12.7057 7.97618 12.2843 9.18405 11.4604 10.1953L15.2244 13.9593C15.4866 14.2777 15.4866 14.596 15.2244 14.9144C14.906 15.1766 14.5877 15.1766 14.2693 14.9144L10.5053 11.1503Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_44"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.730011 15.42)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ee612dd923691a036538d2906c1b32eb.svg";
export { ForwardRef as ReactComponent };